import request from '@/utils/request'

// 查询CMS评论分页
export function pageComment(query) {
  return request({
    url: '/article/comment/page',
    method: 'get',
    params: query
  })
}

// 删除CMS评论
export function delComment(data) {
  return request({
    url: '/article/comment/delete',
    method: 'post',
    data: data
  })
}

// 查询CMS评论详情
export function getComment(id) {
  return request({
    url: '/article/comment/detail?id=' + id,
    method: 'get'
  })
}

